import React, { useContext } from 'react';
import styled from 'styled-components';
import { BlogCard } from 'components';
import { Particles } from 'components';
import { AppContext } from 'App/AppContext';
import { Theme } from 'types';
import './Blog.scss';
import { Toggle } from 'components';
import { HomeButton } from 'components/HomeButton';

const BlogContainer = styled.div<{ $theme: Theme }>`
  position: relative;
  min-height: 100vh;
  background-color: ${({ $theme }) => $theme.background};
  transition: background-color 0.5s linear;
`;

const BlogContent = styled.div`
  position: relative;
  z-index: 1;
`;

const Blog = () => {
  const { theme } = useContext(AppContext);

  return (
    <BlogContainer $theme={theme}>
      <Particles />
      <HomeButton href="/" />
      <BlogContent>
        <Toggle />
        <div className="blog-page">
          <h1>Blog Posts & Articles</h1>
          <div className="cards-container">

          <BlogCard
              title="AI Safety"
              category="What is going to happen when AI builds itself?"
              readTime="6"
              publishedDate="June 10, 2026"
              excerpt="Reflecting on Anthropic's research on recursive self-improvement — from engineering bottlenecks to three future scenarios and why AI literacy matters for everyone."
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/ai-builds-itself"
            />

          <BlogCard
              title="AI Alignment"
              category="Helpful, Harmless, Honest? Limits of RLHF"
              readTime="9"
              publishedDate="March 9, 2026"
              excerpt="HHH made alignment easier to communicate, but real-world trade-offs reveal its limits. A closer look at RLHF, RLAIF, and conflict-heavy safety scenarios."
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/hhh-limits-rlhf"
            />

          <BlogCard
              title="AI Ethics"
              category="Can We Measure Morality and Values in LLMs?"
              readTime="12"
              publishedDate="March 3, 2026"
              excerpt="Exploring the challenges and approaches to measuring morality in AI systems. From MoralBench to FAI frameworks - can we truly capture human values?"
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/morality-llms"
            />

          <BlogCard
              title="Machine Learning"
              category="A Quick Introduction to METEOR"
              readTime="8"
              publishedDate="March 3, 2026"
              excerpt="Understanding METEOR metric for machine translation evaluation. How it addresses BLEU's limitations and why recall matters in translation quality..."
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/meteor-blog"
            />

          <BlogCard
              title="Personal Project"
              category="Building an AI Outfit Creator - Part 2 "
              readTime="10"
              publishedDate="July 2, 2025"
              excerpt="ML Training and Results"
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/drippedup2"
            />

          <BlogCard
              title="Personal Project"
              category="Building an AI Outfit Creator - Part 1 "
              readTime="10"
              publishedDate="June 25, 2025"
              excerpt="Where do you start when you build a project? Software design and ML combined?"
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/drippedup1"
            />


          <BlogCard
              title="Deep Learning"
              category="Xception CNN Architecture"
              readTime="12"
              publishedDate="June 24, 2025"
              excerpt="What is Xception? How does it work? What makes it special? Understanding depthwise separable convolutions..."
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/xception"
            />

          <BlogCard
              title="Deep Learning"
              category="Siamese Neural Networks"
              readTime="15"
              publishedDate="June 19, 2025"
              excerpt="What are siamese neural networks? How do they work and what is it for?..."
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/siamese"
            />

          <BlogCard
              title="Deep Learning"
              category="AlexNet Architecture"
              readTime="10"
              publishedDate="June 15, 2025"
              excerpt="What is AlexNet? How does it work? What are the layers? What are the advantages and disadvantages?"
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/alexnet"
            />
            
            <BlogCard
              title="Life and Tech"
              category="Getting started with blogging..."
              readTime="5"
              publishedDate="June 10, 2025"
              excerpt="Welcome to my blog! This is my first blog post where I'll be sharing my thoughts, experiences..."
              authorMatch={100}
              buttonText="Read Article"
              buttonLink="/first-blog"
            />
            
          </div>
        </div>
      </BlogContent>
    </BlogContainer>
  );
};

export default Blog; 